import { Attrs, MinzeElement } from 'minze'

export interface LvcPictureFrameIcon {
  dataWidth: number
  dataHeight: number
}

export class LvcPictureFrameIcon extends MinzeElement {
  attrs: Attrs = [
    ['data-width', 24],
    ['data-height', 24],
  ]

  html = () => `
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="${this.dataWidth}" 
    height="${this.dataHeight}" 
    viewBox="0 0 44 44" 
    fill="none"
    preserveAspectRatio="xMidYMid meet"
  >
    <g clip-path="url(#clip0_772_104293)">
      <path d="M7.86499 24.1317C8.9152 23.0815 10.3855 22.0313 12.0658 22.0313C14.1663 22.0313 17.3169 27.2823 19.4173 27.2823C21.5177 27.2823 24.6684 17.8304 32.0199 17.8304C34.5404 17.8304 38.6712 20.981 39.3714 22.0313M39.3714 17.8304C39.3714 23.063 39.3714 28.6835 39.3714 31.5855C39.3714 32.125 38.963 32.575 38.4255 32.6216C28.4041 33.4905 15.5059 32.6004 5.76372 32.5369C5.18372 32.5331 4.71436 32.0659 4.71436 31.4859C4.71436 25.7213 4.71436 15.5825 4.71436 10.4775C4.71436 9.89745 5.18221 9.42845 5.76194 9.44675C10.1593 9.5856 17.368 10.4789 20.4675 10.4789C23.6461 10.4789 32.0859 9.53943 38.3226 9.43763C38.9026 9.42816 39.3714 9.89891 39.3714 10.4789C39.3714 11.878 39.3714 13.0507 39.3714 17.8304Z" stroke="#1E007D" stroke-width="2" stroke-linecap="round"/>
      <path d="M12.8189 15.7338C12.3106 15.7684 12.0288 16.1845 12.0699 16.6982C12.1263 17.4046 12.6731 17.89 13.354 17.8239C14.0756 17.7539 14.3852 16.5292 13.9988 15.9814C13.7568 15.6381 13.0875 15.6664 12.8189 15.9411" stroke="#1E007D" stroke-width="2" stroke-linecap="round"/>
    </g>
    <defs>
      <clipPath id="clip0_772_104293">
        <rect width="44" height="44" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  `

  css = () => `
  :host {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  `
}
